<template>
  <div class="row">
    <div class="col-md-12">
      <div class="row">
        <!-- {{broadcastParam}}
        <hr />
        {{broadcastParamSt}}-->
        <div class="col-md-8">
          <div class="col-md-12 profile-info-left">
            <table class="table">
              <tbody>
                <tr>
                  <td class="text-muted text-left" style="width:30%">Title</td>
                  <th class="text-left">{{ broadcastParamSt.title }}</th>
                </tr>

                <tr>
                  <td class="text-muted text-left">Send From</td>
                  <th class="text-left" ref="license_id">
                    <Skeleton :count="1" />
                  </th>
                </tr>
                <tr>
                  <td class="text-muted text-left">Destination &amp; Message</td>
                  <th>
                    &nbsp;
                  </th>
                </tr>
                <tr>
                  <td colspan="2">
                    <div class="card">
                      <div class="card-body" id="preview">
                        <preview-import />
                      </div>
                    </div>
                  </td>

                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="col-md-4">
          <div class="row">
            <div class="col-md-12">
              <label class="col-form-label">
                Sending Speed
                <span class="text text-danger">*</span>
              </label>
              <div class="radio">
                <label :style="'margin-left:10px;'" v-for="(row, index) in listSpeedMode" :key="index"
                  :data-tour-step="'3.' + (index + 1)">
                  <input :id="row.id" type="radio" :value="row.id" v-model="formParam.speed_mode" />
                  {{ row.label }}
                </label>
              </div>
            </div>
            <template v-if="formParam.speed_mode == 'custom'">
              <div class="col-md-12">
                <div class="form-group">
                  <label>Delay Interval (Seconds):</label>

                  <div class="input-group mb-3">
                    <span class="input-group-text">Wait</span>
                    <input @change="formValidate" v-model="formParam.speed_wait_min" type="text" class="form-control"
                      placeholder="Wait Min" aria-label="WaitMin">
                    <span class="input-group-text">to</span>
                    <input @change="formValidate" v-model="formParam.speed_wait_max" type="text" class="form-control"
                      placeholder="Wait Max" aria-label="WaitMax">
                    <span class="input-group-text">Seconds</span>

                  </div>
                </div>

              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <label>Rest Mode:</label>

                  <div class="input-group mb-3">
                    <input @change="formValidate" v-model="formParam.speed_stop_after" type="text" class="form-control"
                      placeholder="Stop sending after" aria-label="StopAfter">
                    <span class="input-group-text">messages</span>
                  </div>
                  <div class="input-group mb-3">
                    <input @change="formValidate" v-model="formParam.speed_rest_for" type="text" class="form-control"
                      placeholder="and rest for" aria-label="RestFor">
                    <span class="input-group-text">seconds</span>
                  </div>
                </div>
              </div>
            </template>

          </div>

          <div class="row">
            <div class="col-md-12">
              <label class="col-form-label">
                Sending Options
                <span class="text text-danger">*</span>
              </label>
              <div class="radio">
                <label :style="'margin-left:10px;'" v-for="(row, index) in listSendingOptions" :key="index"
                  :data-tour-step="'3.' + (index + 1)">
                  <input :id="row.id" type="radio" :value="row.id" v-model="formParam.sending_options"
                    @change="formValidate" />
                  {{ row.label }}
                </label>
              </div>
            </div>
            <div class="col-md-12" v-if="formParam.sending_options == '2'">
              <div class="form-group">
                <label>Time to send:</label>

                <div class="cal-icon">
                  <datetime :min-datetime="currentDateTimeUTC()" :zone="'local'" :use12-hour="true"
                    input-class="form-control" value-zone="UTC" type="datetime" v-model="sendingSchedule"></datetime>

                  <!-- <input type="text" class="form-control floating datetimepicker" /> -->
                </div>
                <!-- <span
                    v-if="broadcastParam.sending_schedule!=''"
                >UTC: {{broadcastParam.sending_schedule}}</span>-->
              </div>
            </div>
            <div class="row" v-if="broadcastParam.sending_options == '3'">
              <div class="col-md-12">
                <div class="form-group">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="input-group m-b-30">
                        <input type="text" placeholder="Phone number to test" class="form-control"
                          v-model="broadcastParam.to_test_text" />
                        <div class="input-group-append">
                          <button @click="bcMessageHandlerTest" class="btn btn-warning" type="button">
                            <i class="fa fa-send"></i>
                          </button>
                        </div>
                        <small class="text-muted">Type phone number and separate with comma for many test
                          destination.</small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <scheduler :activeIndex="activeIndex" />
        </div>
      </div>
    </div>
    <v-tour name="tourGuide3" :steps="tourSteps" :callbacks="tourCallbacks"></v-tour>

  </div>
</template>

<script>
import { Skeleton } from "vue-loading-skeleton";
import { currentDateTimeUTC } from "@/utils/helper";
import Scheduler from "./scheduler.vue";
import { Datetime } from "vue-datetime";
// You need a specific loader for CSS files
import "vue-datetime/dist/vue-datetime.css";
import PreviewMessage from "./preview";
import PreviewImport from "./previewImport";

export default {
  components: {
    Skeleton,
    Scheduler,
    Datetime,
    PreviewMessage,
    PreviewImport,
  },
  props: {
    activeIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      tourId: "broadcast.step3",
      tourCallbacks: {
        onSkip: this.tourComplete,
        onFinish: this.tourComplete
      },
      tourSteps: [
        {
          target: '[data-tour-step="3.1"]', // We're using document.querySelector() under the hood
          content: `<b>Now</b>: Pesan broadcast akan langsung dikirim.`
        },
        {
          target: '[data-tour-step="3.2"]',
          content: `<b>Schedule</b>: Pesan akan dikirim sesuai jadwal yang ditentukan.`
        },
        {
          target: '[data-tour-step="3.3"]',
          content:
            "<b>Send a test</b>: Sebelum broadcast dikirim, kamu bisa cek dulu ke nomor yang ditentukan. Pisahkan dengan koma untuk mengirim ke beberapa nomor sekaligus."
        },
        {
          target: '[data-tour-step="3.4"]',
          content:
            "<b>Recurring</b>: Pesan akan dikirim secara berulang sesuai dengan Frequency yang ditentukan."
        }
      ],
      broadcastParam: {
        to_test: [],
        to_test_text: ""
      },
      whatsappBackground: process.env.VUE_APP_WHATSAPP_BACKGROUND,
      buttonsLoading: false,
      defaultDetailButton: 10,
      linkParams: {
        columnFilters: {
          button_title: "",
          button_text: "",
          button_response: ""
        },
        page: 1,
        perPage: 500 // perPage
      },
      buttonsParams: {
        columnFilters: {
          button_title: "",
          button_text: "",
          button_response: ""
        },
        page: 1,
        perPage: 500 // perPage
      },
      linkRows: [],
      buttonsRows: [],
      sendingSchedule: "",
      formParam: {
        speed_mode: "safe",
        speed_wait_min: '0',
        speed_wait_max: '0',
        speed_stop_after: '0',
        speed_rest_for: '0',
        sending_options: 1,
        sending_schedule: ""
      },
      listSendingOptions: [
        { id: 1, label: "Now" },
        { id: 2, label: "Schedule" },
        // { id: 3, label: "Send a test" }
      ],
      listSpeedMode: [
        { id: 'safe', label: "Safe" },
        { id: 'normal', label: "Normal" },
        { id: 'fast', label: "Fast" },
        { id: 'custom', label: "Custom" }
      ],
      isLoading: false
    };
  },
  watch: {
    broadcastParamSt: {
      handler: async function (val, oldVal) {
        if (val != oldVal) {
          this.formParam.is_publish = 1;
          this.formParam.speed_mode = val.speed_mode;
          this.formParam.speed_wait_min = val.speed_wait_min;
          this.formParam.speed_wait_max = val.speed_wait_max;
          this.formParam.speed_stop_after = val.speed_stop_after;
          this.formParam.speed_rest_for = val.speed_rest_for;
          // this.formParam.form_speed = val.form_speed;
          // this.formParam.form_speed.delay_interval.wait_min = val.form_speed.delay_interval.wait_min;
          // this.formParam.form_speed.delay_interval.wait_max = val.form_speed.delay_interval.wait_max;
          // this.formParam.form_speed.rest_mode.stop_after = val.form_speed.rest_mode.stop_after;
          // this.formParam.form_speed.rest_mode.rest_for = val.form_speed.rest_mode.rest_for;
          this.formParam.sending_options = val.sending_options;
          this.formParam.sending_schedule = val.sending_schedule;
          this.sendingSchedule = val.sending_schedule;
        }
      },
      deep: true
    },
    sendingSchedule: {
      handler: async function (val, oldVal) {
        if (val != oldVal) {
          this.formValidate();
        }
      },
      deep: true
    },
    activeIndex: {
      handler: async function (val, oldVal) {
        if (val == 2) {
          this.tourDetail();
          // that.getMarketplaceList();
          this.loadReplyButtons();
          this.loadReplyLink();
          await this.getLabel();
          this.formValidate();
        }
      },
      deep: true
    },
    broadcastParam: {
      handler: function (val, oldVal) {
        this.formValidate();
      },
      deep: true
    }
  },
  computed: {
    broadcastParamSt() {
      return this.$store.state.omniwa.broadcastParamSt;
    },
    detailBroadcast() {
      return this.$store.state.omniwa.detailBroadcast;
    }
  },
  filters: {
    capitalising: function (data) {
      var capitalized = [];
      data.split(" ").forEach(word => {
        capitalized.push(
          word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        );
      });
      return capitalized.join(" ");
    }
  },
  methods: {
    tourShow() {
      this.$tours["tourGuide3"].start();
    },
    tourComplete() {
      let params = {};
      params = {
        tour_id: this.tourId
      };
      this.$store.dispatch("tour/tourComplete", params);
    },
    tourDetail() {
      let params = {};
      params = {
        tour_id: this.tourId
      };
      this.$store.dispatch("tour/tourDetail", params).then(response => {
        var { data } = response;
        if (data.id == "") {
          this.tourShow();
        }
      });
    },
    async buildDestinationTest() {
      this.broadcastParam.to_test = [];
      this.broadcastParam.to_test_text = this.broadcastParam.to_test_text.replace(
        /^\s+|\s+$/gm,
        ""
      );

      if (this.broadcastParam.to_test_text != "") {
        var toTestArr = this.broadcastParam.to_test_text.split(",");
        toTestArr.forEach((phoneNumber, idx) => {
          phoneNumber = phoneNumber.replace(/^\s+|\s+$/gm, "");
          let oriNumber = phoneNumber;
          phoneNumber = parseInt(phoneNumber);
          if (phoneNumber != "" && !isNaN(phoneNumber)) {
            let newArr = {
              id: idx.toString(),
              phone_number: oriNumber
            };
            this.broadcastParam.to_test.push(newArr);
          }
        });
      }
    },
    remove_tags(html) {
      var html = html.replace("<br />", "||br||");
      var tmp = document.createElement("DIV");
      tmp.innerHTML = html;
      html = tmp.textContent || tmp.innerText;
      return html.replace("||br||", "<br />");
    },
    async bcMessageHandlerTest() {
      await this.buildDestinationTest();
      // console.log("this.totest", this.broadcastParam.to_test);
      this.broadcastParam.is_send = 1;

      //validasi data
      if (
        this.broadcastParam.to_test.length == 0 ||
        this.broadcastParam.to_test_text == ""
      ) {
        //error no destination
        // error
        this.$fire({
          title: "Error",
          text: "Test Destination is required!",
          type: "error",
          timer: 2000
        }).then(r => { });
        return;
      }
      if (
        this.broadcastParam.message.message_type != "text" &&
        this.broadcastParam.message.file_url == ""
      ) {
        //error no media
        this.$fire({
          title: "Error",
          text:
            "File is required for " +
            this.broadcastParam.message.message_type +
            " message!",
          type: "error",
          timer: 2000
        }).then(r => { });
        return;
      }

      // if (
      //   this.broadcastParam.message.message_type == "text" &&
      //   this.broadcastParam.message.text.trim() == ""
      // ) {
      //   //error no text for type text
      //   this.$fire({
      //     title: "Error",
      //     text:
      //       "Text is required for " +
      //       this.broadcastParam.message.message_type +
      //       " message!",
      //     type: "error",
      //     timer: 2000
      //   }).then(r => { });
      //   return;
      // }

      // return;

      this.$fire({
        title: "Are you sure you will continue this action?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      }).then(async r => {
        // console.log("rrrr", r);
        // return;
        if (r.value == true) {
          this.isSending = await true;
          // this.emojiToggle(false);
          var origText = this.broadcastParam.message.text;
          this.broadcastParam.message.text = await this.remove_tags(
            this.broadcastParam.message.text
          );
          let newButtons = [];
          // console.log("this.broadcastParam.buttons",this.broadcastParam.buttons)
          if (this.broadcastParam.interactive_message_status == true) {
            // newButtons = this.broadcastParam.buttons;
            if (this.broadcastParam.buttons.length) {
              this.broadcastParam.buttons.forEach((btnId, idx) => {
                if (btnId != "") {
                  newButtons.push(btnId);
                }
              });
            }
          }

          this.broadcastParam.buttons = newButtons;
          await this.$store
            .dispatch("omniwa/sendBroadcastTest", this.broadcastParam)
            .then(response => {
              this.$fire({
                title: "Success Test",
                text: response["msg"],
                type: "success",
                timer: 2000
              }).then(r => { });
              this.isSending = false;
            })
            .catch(() => {
              this.isSending = false;
            });
        }
        this.broadcastParam.message.text = origText;
      });
    },
    async loadReplyLink() {
      this.buttonsLoading = await true;
      this.linkParams.page = 0;
      await this.$store
        .dispatch("automation/listReplyLink", this.linkParams) // sesuai kan dengan method di API
        .then(response => {
          const { data } = response;
          this.linkRows = data.data;
          this.buttonsLoading = false;
        })
        .catch(error => {
          this.buttonsLoading = false;
          console.log(error);
        });
    },
    async loadReplyButtons() {
      this.buttonsLoading = await true;
      this.buttonsParams.page = 0;
      await this.$store
        .dispatch("automation/listReplyButtons", this.buttonsParams) // sesuai kan dengan method di API
        .then(response => {
          const { data } = response;
          this.buttonsRows = data.data;
          this.buttonsLoading = false;
        })
        .catch(error => {
          this.buttonsLoading = false;
          console.log(error);
        });
    },
    messageFilter(message) {
      return message.replace(/\r?\n/g, "<br />");
    },
    formValidate() {

      let newParam = this.broadcastParamSt;
      let to_test = this.broadcastParam.to_test;
      let to_test_text = this.broadcastParam.to_test_text;
      this.broadcastParam = newParam;
      this.broadcastParam.to_test = to_test;
      this.broadcastParam.to_test_text = to_test_text;
      newParam.to_test = to_test;
      newParam.to_test_text = to_test_text;
      newParam.is_publish = 1;
      newParam.is_publish = 1;
      newParam.speed_mode = this.formParam.speed_mode;
      newParam.speed_wait_min = this.formParam.speed_wait_min;
      newParam.speed_wait_max = this.formParam.speed_wait_max;
      newParam.speed_rest_for = this.formParam.speed_rest_for;
      newParam.speed_stop_after = this.formParam.speed_stop_after;
      // newParam.form_speed.delay_interval.wait_min = this.formParam.form_speed.delay_interval.wait_min;
      // newParam.form_speed.delay_interval.wait_max = this.formParam.form_speed.delay_interval.wait_max;
      // newParam.form_speed.rest_mode.stop_after = this.formParam.form_speed.rest_mode.stop_after;
      // newParam.form_speed.rest_mode.rest_for = this.formParam.form_speed.rest_mode.rest_for;
      newParam.sending_options = this.formParam.sending_options;
      newParam.sending_schedule = this.sendingSchedule;
      console.log("newParamnewParam", newParam)
      this.$store.dispatch("omniwa/actBroadcastParamSt", newParam);

      // this.$store.dispatch("instagramSchedule/actFormParamScrapeSt", newParam);
      // console.log("newParamForm3", newParam);
    },

    async getLabel() {
      await this.$store
        .dispatch("license/getLicenseById", this.broadcastParamSt.license_id)
        .then(response => {
          var { data } = response;
          this.licenseInfo = data;
          this.$refs.license_id.innerHTML = data.license_name;
          this.$refs.license_id.innerHTML +=
            '<br /><span class="text-muted"><i class="fa fa-phone"></i> ' +
            data.license_phone_number +
            "</span>";
          this.$store
            .dispatch("omniwa/isOnline", data.license_phone_number)
            .then(responseDet => {
              var { data } = responseDet;

              if (data.status === 1) {
                this.$refs.license_id.innerHTML +=
                  ' <i title="Online" class="text-success fa fa-signal"></i>';
              } else {
                this.$refs.license_id.innerHTML +=
                  ' <i title="Offline" class="text-danger fa fa-signal"></i>';
              }
            });
        });
    },
    currentDateTimeUTC() {
      return currentDateTimeUTC();
    }
  },
  async created() { },
  beforeDestroy() { },
  mounted() { },
  name: "form-3"
};
</script>


// WEBPACK FOOTER //
// src/views/broadcast/componentsImport/form3.vue